import React, { useEffect } from 'react';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateSingleDevicePageSelectedRastersDictionary,
  updateSingleDevicePageHeatmapLibraryTableSetSelectAll,
  doGetRasterRecord
} from 'redux/actions';
import { Status } from 'common/utils/constants';
import './HeatmapLibraryTableIdCell.css';

const HeatmapLibraryTableIdCell = (props) => {
  let selectedRastersDictionary = useSelector((store) => store.ui.singleDevicePage.heatmap.selectedRastersDictionary);
  const dispatch = useDispatch();

  const getRasterRecordStatusName = `GET-RasterRecord-${props.rasterId}`;
  const getRasterRecordStatus = useSelector((store) => store.statuses[getRasterRecordStatusName]);

  useEffect(() => {
    if (!selectedRastersDictionary && Object.keys(props.deviceHeatmapHistoryDictionary)?.length > 0) {
      let selectionDictionary = {};
      let rasterIds = Object.keys(props.deviceHeatmapHistoryDictionary) ?? [];
      rasterIds.forEach((rasterId) => {
        selectionDictionary[rasterId] = false;
      });
      dispatch(updateSingleDevicePageSelectedRastersDictionary(selectionDictionary));
    }
  }, [props.deviceHeatmapHistoryDictionary]);

  const sendSelected = (selected, rasterId) => {
    let newLocalSelectedDeviceHeatmapDictionary = { ...selectedRastersDictionary };
    selected
      ? (newLocalSelectedDeviceHeatmapDictionary[rasterId] = true)
      : (newLocalSelectedDeviceHeatmapDictionary[rasterId] = false);

    let isAllChecked = Object.keys(newLocalSelectedDeviceHeatmapDictionary).every(
      (rasterId) => newLocalSelectedDeviceHeatmapDictionary[rasterId] === true
    );

    getRasterRecordStatus !== Status.SUCCESS &&
      getRasterRecordStatus !== Status.PENDING &&
      selected &&
      dispatch(doGetRasterRecord(props.donorDevice, props.rasterId));
    dispatch(updateSingleDevicePageHeatmapLibraryTableSetSelectAll(isAllChecked));
    dispatch(updateSingleDevicePageSelectedRastersDictionary(newLocalSelectedDeviceHeatmapDictionary));
  };

  return (
    <div
      id="HeatmapLibraryTable_IdCell"
      className="HeatmapLibraryTable_IdCell"
      data-tip={props.sourceText}
      key={Math.random() * 10}
    >
      <div id="HeatmapLibraryTable_IdCell_DefaultSection" className="HeatmapLibraryTable_IdCell_DefaultSection">
        <div id="HeatmapLibraryTable_IdCell_Checkbox" className="HeatmapLibraryTable_IdCell_Checkbox">
        <Checkbox
          isChecked={selectedRastersDictionary?.[props.rasterId]}
          onChange={(event) => {
            let rasterId = props.rasterId;
            let selected = !selectedRastersDictionary?.[rasterId];

            sendSelected(selected, rasterId);

            event.stopPropagation(); //stop default row click stuff from happening
          }}
        />
        </div>

        <span id="HeatmapLibraryTable_IdCell_SourceString" className="HeatmapLibraryTable_IdCell_SourceString">
          {props.sourceText}
        </span>
      </div>
    </div>
  );
  // }
};

export default React.memo(HeatmapLibraryTableIdCell);
